<template lang="pug">
	.card
		.card-header
			span.fa.fa-filter.mr-2
			| Filtrar
		.card-body
			.row
				.col(v-if="permisos.cobros_verTodasLasComisiones")
					.form-group
						label Agente
						input.form-control.form-control-sm(v-model="filtro.AgenteNombre" @keypress.enter="buscar")
				.col
					.form-group
						label Desde el mes
						.input-group
							datepicker(
								input-class="form-control form-control-sm"
								v-model="filtro.Mes"
								minimum-view="month"
								format="MMMM, yyyy"
								:language="$dateLang"
								@input="buscar"
							)
							.input-group-append
								button.btn.btn-sm.btn-danger(@click="quitarFecha")
									span.fa.fa-trash
				.col
					.form-group
						label Estado
						br
						.btn-group
							button.btn.btn-sm(:class="(filtro.Estado === null) ? 'btn-primary' : ''", @click="setEstado(null)") Todos
							button.btn.btn-sm(:class="(filtro.Estado === 'Pagado') ? 'btn-primary' : ''", @click="setEstado('Pagado')") Pagadas
							button.btn.btn-sm(:class="(filtro.Estado === 'Pendiente') ? 'btn-primary' : ''", @click="setEstado('Pendiente')") Pendientes
				.col
					.form-group
						label Contratos
						br
						label
							input.mr-3(type="checkbox")
							| Mostrar solo recibos de contratos totalmente pagados
		.card-footer
			button.btn.btn-sm.m-1.btn-primary(@click="buscar")
				span.fa.fa-search.mr-2
				| Buscar

			button.btn.btn-sm.m-1.btn-warning(@click="editarComision = 'nueva'")
				span.fa.fa-edit.mr-2
				| Pagar comisión

		Comision(:ComisionID="editarComision", v-if="editarComision", @cerrar="editarComision = null", @actualizar="buscar")
</template>

<script>
import Comision from './editarPago.vue'
import { mapGetters } from 'vuex'
export default {
	props: ['filtro'],
	components: {
		Comision
	},
	data () {
		return {
			editarComision: null
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		setEstado (estado) {
			this.filtro.Estado = estado
			this.buscar()
		},
		quitarFecha () {
			this.filtro.Mes = null
			this.buscar()
		},
		buscar () {
			this.$emit('buscar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/comisiones/filtro.vue